import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";

export default function Waiter() {
  const [tables, setTables] = useState([]);

  useEffect(() => {
    fetchTables();
  }, []);

  const fetchTables = async () => {
    const res = await api.get("/api/tables");
    setTables(res.data);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>🍽 Waiter Dashboard</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
        {tables.map((t) => (
          <Link
            key={t._id}
            to={`/waiter/table/${t._id}`}
            style={{
              width: 120,
              height: 120,
              background: t.status === "occupied" ? "#f77" : "#7f7",
              borderRadius: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textDecoration: "none",
              color: "black",
              fontWeight: "bold",
              fontSize: 18,
            }}
          >
            {t.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
